import { PermissionRules, PERMISSIONS, ROLES } from '@teamworksdev/influencer/core';
import { isAgent, isBrandBusiness, isBrandUser, isComplianceOfficer, isTeamUser } from './roles';

const hasExchangeWrite = isBrandUser;

const editAgreements = PermissionRules.or(
	hasExchangeWrite,
	isComplianceOfficer,
);

const accessBulletins = PermissionRules.or(
	isBrandBusiness,
	isAgent,
);

const accessTransactionsPermissions = [
	PERMISSIONS.TRANSACTIONS_READ,
	PERMISSIONS.TRANSACTIONS_WRITE,
];
const accessTransactions = PermissionRules.or(
	PermissionRules.hasAnyRole([
		ROLES.BRAND_USER,
		ROLES.COMPLIANCE_OFFICER,
	]),
	PermissionRules.hasAnyTeamPermission(accessTransactionsPermissions),
	PermissionRules.hasAnyAgentPermission(accessTransactionsPermissions),
);

const canReportTransactions = PermissionRules.or(
	PermissionRules.hasAgentPermission(PERMISSIONS.TRANSACTIONS_WRITE),
	PermissionRules.hasTeamPermission(PERMISSIONS.TRANSACTIONS_WRITE),
);

const hasTransactionWrite = PermissionRules.hasTeamPermission(PERMISSIONS.TRANSACTIONS_WRITE);

const updateAgreementStatuses = PermissionRules.or(
	isAgent,
	isTeamUser,
	hasExchangeWrite,
);

const updateTransactionStatuses = PermissionRules.or(
	isAgent,
	isTeamUser,
	hasExchangeWrite,
);

const createConversations = PermissionRules.or(
	isBrandUser,
	isBrandBusiness,
);

const hasLeaderboardRead = PermissionRules.or(
	PermissionRules.hasAnyAgentPermission([
		PERMISSIONS.LEADERBOARD_READ,
	]),
	PermissionRules.hasAnyTeamPermission([
		PERMISSIONS.LEADERBOARD_READ,
		PERMISSIONS.LEADERBOARD_WRITE,
	]),
);

const accessTasks = PermissionRules.or(
	PermissionRules.hasAnyTeamPermission([
		PERMISSIONS.TRANSACTIONS_READ,
		PERMISSIONS.TRANSACTIONS_WRITE,
	]),
	PermissionRules.hasAnyAgentPermission([
		PERMISSIONS.TRANSACTIONS_READ,
		PERMISSIONS.TRANSACTIONS_WRITE,
	]),
	PermissionRules.hasAnyRole([
		ROLES.COMPLIANCE_OFFICER,
		ROLES.BRAND_USER,
	]),
);

const canUpdateTaskStatus = PermissionRules.hasAnyRole([
	ROLES.TEAM_USER,
	ROLES.BRAND_USER,
	ROLES.AGENT,
]);

export {
	accessBulletins,
	accessTransactions,
	accessTasks,
	canReportTransactions,
	canUpdateTaskStatus,
	editAgreements,
	hasExchangeWrite,
	hasTransactionWrite,
	updateAgreementStatuses,
	updateTransactionStatuses,
	createConversations,
	hasLeaderboardRead,
};
